import {
  put, takeLatest, takeEvery, select, all,
} from 'redux-saga/effects';
import {
  TeammoApi,
  normalize,
  compilePaginationObject,
} from 'app/utils/redux/helpers';
import { reminderSchema, reminderListSchema } from 'app/utils/redux/schemas';
import { handleError } from 'app/utils/handlers/handleError';
import {
  loadingStart,
  loadingFinish,
  actionConfirmed,
} from 'app/ducks/loading/actions';
import { sagaActions } from 'app/ducks/reminders/actions';
import { RemindersActionTypes as types } from 'app/ducks/reminders/types';

function* createReminderSaga(action): any {
  yield put(sagaActions.createReminderPending(action.payload));
  const [error, response] = yield (yield TeammoApi(yield select())).teamReminders.create(
    action.payload,
  );

  if (response) {
    const normalizedResponse = normalize(response, reminderSchema);
    yield put(actionConfirmed('Reminder successfully sent!', 'success'));
    yield put(sagaActions.createReminderSuccess(normalizedResponse));
  } else {
    yield put(
      actionConfirmed(
        'Reminder has already been sent in the last 24 hours.',
        'error',
      ),
    );
    yield put(
      handleError(
        error,
        sagaActions.createReminderFailed(
          _.isEmpty(error) ? {} : error.response.data.errors,
        ),
      ),
    );
  }
}

function* updateReminderSaga(action): any {
  yield put(sagaActions.updateReminderPending(action.payload));
  const [error, response] = yield (yield TeammoApi(yield select())).teamReminders.update(
    action.payload,
  );

  if (response) {
    const normalizedResponse = normalize(response, reminderSchema);

    yield put(sagaActions.updateReminderSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.updateReminderFailed(
          _.isEmpty(error) ? {} : error.response.data.errors,
        ),
      ),
    );
  }
}

function* getReminderSaga(action): any {
  yield put(sagaActions.getReminderPending());
  const [error, response] = yield (yield TeammoApi(yield select())).teamReminders.show(
    action.payload,
  );
  if (response) {
    const normalizedResponse = normalize(response, reminderSchema);
    yield put(sagaActions.getReminderSuccess(normalizedResponse));
    return normalizedResponse.entities.reminders[normalizedResponse.result];
  }
  yield put(
    handleError(
      error,
      sagaActions.getReminderFailed(
        _.isEmpty(error) ? {} : error.response.data.errors,
      ),
    ),
  );
  return null;
}

function* getAllRemindersSaga(action): any {
  yield put(
    sagaActions.getAllRemindersPending(
      action.payload.compile ? action.payload.pagination : {},
    ),
  );
  yield put(loadingStart());

  const paginationObject = action.payload.compile
    ? compilePaginationObject(
      yield select((state) => state.reminders.pagination),
    )
    : action.payload.pagination;

  const [error, response] = yield (
    yield (yield TeammoApi(yield select()))
  ).teamReminders.organisationList(
    action.payload.organisationId,
    paginationObject,
  );

  if (response) {
    const normalizedResponse = normalize(response, reminderListSchema);

    yield put(
      sagaActions.getAllRemindersSuccess(normalizedResponse, response.meta),
    );
    yield put(loadingFinish());
  } else {
    yield put(
      error,
      sagaActions.getAllRemindersFailed(
        _.isEmpty(error) ? {} : error.response.data.errors,
      ),
    );
  }
}

/* ********************************* SAGA WATCHERS ********************************* */

function* createReminderSagaWatcher(): any {
  yield takeLatest(types.CREATE_REMINDER_REQUESTED, createReminderSaga);
}

function* updateReminderSagaWatcher(): any {
  yield takeLatest(types.UPDATE_REMINDER_REQUESTED, updateReminderSaga);
}

function* getReminderSagaWatcher(): any {
  yield takeEvery(types.GET_REMINDER_REQUESTED, getReminderSaga);
}

function* getAllRemindersSagaWatcher(): any {
  yield takeEvery(
    types.GET_ALL_REMINDERS_REQUESTED,
    getAllRemindersSaga,
  );
}

export default function* root(): any {
  yield all([
    createReminderSagaWatcher(),
    updateReminderSagaWatcher(),
    getReminderSagaWatcher(),
    getAllRemindersSagaWatcher(),
  ]);
}
